<template>
  <div class="cj-page">

    <!-- Hero -->
    <div class="cj-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-cash-register</v-icon>
        </v-avatar>
        <div>
          <div class="cj-hero__title">Gestión de Cajas</div>
          <div class="cj-hero__sub">Control de apertura y cierre de cajas por sede</div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark class="cj-hero__chip">
        <v-icon left small>mdi-bank-outline</v-icon> Contabilidad
      </v-chip>
    </div>

    <div class="cj-body">

      <!-- Barra de herramientas -->
      <v-card outlined class="cj-toolbar-card mb-4">
        <v-card-text class="py-2 px-4">
          <div class="d-flex align-center justify-space-between flex-wrap" style="gap:8px;">
            <div class="d-flex align-center" style="gap:8px;">
              <v-btn small outlined color="blue darken-2" @click="cargarDatos()" :loading="loading">
                <v-icon left small>mdi-refresh</v-icon> Actualizar
              </v-btn>
              <v-chip x-small :color="desserts.length ? 'blue lighten-5' : 'grey lighten-3'"
                class="blue--text text--darken-2 font-weight-medium">
                {{ desserts.length }} registro{{ desserts.length !== 1 ? 's' : '' }}
              </v-chip>
            </div>
            <v-switch v-model="eliminados" dense hide-details inset color="red darken-1"
              :label="eliminados ? 'Incluir eliminados' : 'Solo activos'"
              class="mt-0 cj-switch" />
          </div>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="cj-table-card">
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="desserts" 
          loading-text="Cargando cajas..."
          no-data-text="No hay cajas registradas"
          class="cj-table"
        >
          <!-- Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip x-small label
              :color="item.estado ? 'green lighten-5' : 'red lighten-5'"
              :class="item.estado ? 'green--text text--darken-2' : 'red--text text--darken-2'">
              <v-icon left x-small>{{ item.estado ? 'mdi-lock-open-variant-outline' : 'mdi-lock-outline' }}</v-icon>
              {{ item.estado ? 'Abierta' : 'Cerrada' }}
            </v-chip>
          </template>

          <!-- Eliminado en -->
          <template v-slot:[`item.deleted_at`]="{ item }">
            <span v-if="item.deleted_at" class="red--text text--darken-1 text-caption">{{ item.deleted_at }}</span>
            <span v-else class="grey--text">—</span>
          </template>

          <!-- Eliminado por -->
          <template v-slot:[`item.deleted_by`]="{ item }">
            <span v-if="item.deleted_by" class="red--text text--darken-1 text-caption">{{ item.deleted_by }}</span>
            <span v-else class="grey--text">—</span>
          </template>

          <!-- Montos -->
          <template v-slot:[`item.monto_apertura`]="{ item }">
            <span class="font-weight-medium">{{ item.monto_apertura }}</span>
          </template>
          <template v-slot:[`item.monto_cierre`]="{ item }">
            <span :class="item.monto_cierre ? 'teal--text text--darken-1 font-weight-medium' : 'grey--text'">
              {{ item.monto_cierre || '—' }}
            </span>
          </template>

          <!-- Acciones -->
          <template v-slot:[`item.opt`]="{ item }">
            <div class="d-flex align-center" style="gap:2px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small
                    color="red darken-1" :disabled="!item.estado" @click="opencierre(item)">
                    <v-icon small>mdi-lock-outline</v-icon>
                  </v-btn>
                </template>
                <span>Cerrar caja</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small
                    color="blue darken-1" @click="obtenerDetalles(item.id)">
                    <v-icon small>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small
                    color="teal darken-1" :disabled="item.estado" @click="obtenerReporte(item.id)">
                    <v-icon small>mdi-file-download-outline</v-icon>
                  </v-btn>
                </template>
                <span>Descargar reporte</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small
                    color="indigo darken-1" :disabled="item.estado"
                    @click="$router.push('/depositos?idcaja='+item.id)">
                    <v-icon small>mdi-bank-transfer</v-icon>
                  </v-btn>
                </template>
                <span>Ver depósitos</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>

    </div>

    <contador ref="refcontador" v-on:success="cargarDatos"/>
    <registrar ref="refagregar" v-on:success="cargarDatos"/>
    <cierre ref="refcierre" v-on:onclose="cargarDatos"/>
    <abierta ref="refabierta" v-on:success="cargarDatos"/>
    <registrarv2 ref="refagregarv2" v-on:success="cargarDatos"/>
  </div>
</template>

<script>
import contador from './contador.vue';
import registrar from './registrar.vue';
import registrarv2 from './registrarv2.vue';
import cierre from './cierre.vue';
import abierta from './caja-abierta-view.vue';
import xaxios from '@/xaxios';

export default {
    components:{contador,registrar,cierre,abierta,registrarv2},
    data () {
        return {
            headers: [ 
                { text: '#', value: 'nro' },
                { text: 'Monto apertura', value: 'monto_apertura' }, 
                { text: 'fecha apertura', value: 'fecha_apertura' },
                { text: 'fecha cierre', value: 'fecha_cierre' },
                { text: 'monto cierre', value: 'monto_cierre' }, 
                { text: 'estado', value: 'estado' },
                { text: 'Usuario', value: 'created_by' }, 
                { text: '', value: 'opt' },
            ],
            desserts: [],
            eliminados: false,
            loading: false,
        }
    },
    watch:{
        eliminados: function(){
            this.cargarDatos();
        },
        '$store.state.CARGO': function(){
            this.cargarDatos();
        }
    },
    methods:{
        opennominaciones(){
            this.$router.push('/nominaciones')
        },
        openregistrar(item=null){
            this.$refs.refagregar.openmodal(item);
        },
        opencontador(item=null){
            this.$refs.refcontador.openmodal(item);
        },
        async opencierre(item){
            this.loading = true;
            const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/${item.id}?detalle=true&recibos=true`
            const res = await xaxios.get(url).then(x=>x).catch(x=>x); 
            if(res && res.data){
                window.console.log('>>> res',res);
                let cajita = res.data;
                this.$refs.refcierre.openmodal(cajita);
            }
            this.loading = false;
    
        },
        openabierta(item=null){
            this.$refs.refabierta.openmodal(item);
        },
        // openrefagregarv2(item=null){
        //     this.$refs.refagregarv2.openmodal(item);
        // },
        async cargarDatos(){
            let idrol = this.$store.state.CARGO.id;
            let idsede = this.$store.state.CARGO.sede.id;
            let iduser = this.$store.state.DATA_USER.id;
            if(idrol != 1 && idrol != 14 && idrol != 15 && idrol != 25 ){
                this.$root.$notify.show(`Rol no autorizado`, { color: 'red', x: 'right' });
                return;
            }
            // window.console.log('rol:',idrol,iduser,idsede);
            
            this.loading = true;
            this.desserts = [];
            
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas?sedeID=${idsede}`; 

            const damarisid = 73951;
            if(this.eliminados) url += '&eliminados=true'; 
            if((idrol == 15 || idrol == 25) && iduser != damarisid ) url += `&userID=${iduser}`;
            
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            if(res && res.data ) {
                res.data.data.map((x,i)=>{
                    x,
                    x.nro = i+1
                })
                let d = res.data.data.filter(x=>x.id != 2 && x.id != 27)
                this.desserts = d.reverse();
            }
            this.loading = false;
        },
        confirmacionDelete(item) {
            const vue = this;
            var opt = {
                verification: 'eliminar',
                verificationHelp: 'Escriba "[+:verification]" para eliminar esta nominacion.',
                okText: 'eliminar',
                cancelText: 'cancelar',
                backdropClose: false,
                animation: 'bounce',
                loader: true,
                type: 'hard',
            };
            var message = {
                title: 'Confirmar',
                body:
                    '<br> <b>NOTA:</b> Una ves realizada la accion no hay vuelta atras </br></br>',
            };
            this.$dialog
            .confirm(message, opt)
            .then(async function(dialog) { 
                const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/caja/${item.id}`;
                const res = await xaxios.delete(url).then(x=>x).catch(x=>x);
                window.console.log(res);
                dialog.close();
                vue.cargarDatos();
            }).catch(function() {});
        },
        async obtenerDetalles(cajaid){
            this.loading = true; 
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/${cajaid}?detalle=true&recibos=true`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            if(res && res.data ){
                window.console.log('res',res);
                this.openabierta(res.data);
            }
            this.loading = false;
        },
        async obtenerReporte(cajaid){
            this.loading = true; 
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/reporte/${cajaid}`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            if(res && res.data ){
                window.console.log('res',res);

                const imgUri = this.getdatauri(res.data.data);
                const link = document.createElement('a')
                document.body.appendChild(link)

                link.href = imgUri
                link.target = '_self' 
                link.fileName = `CierreCaja-${res.data.data.created_at}.${res.data.data.extencion}`;
                link.download = `CierreCaja-${res.data.data.created_at}.${res.data.data.extencion}`;
                link.click()
            }
            this.loading = false;
        },
        getdatauri(archivo){
            if(!archivo) return '';
            return `data:${archivo.mimetype};base64,${archivo.file64}`
        }, 
        openDeta(cajaid){
            this.$refs.refagregarv2.openmodal(cajaid);
        }
    },
    async mounted(){ 
        this.cargarDatos();
        
    }
}
</script>

<style scoped>
.cj-page {
  min-height: 100vh;
  background: #f5f7fa;
}

/* ── Hero ─────────────────────────────────────────────────────────── */
.cj-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.cj-hero__title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}
.cj-hero__sub {
  font-size: 0.78rem;
  color: rgba(255,255,255,0.65);
  margin-top: 2px;
}
.cj-hero__chip {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}

/* ── Body ─────────────────────────────────────────────────────────── */
.cj-body {
  padding: 20px 24px;
}

/* ── Toolbar card ─────────────────────────────────────────────────── */
.cj-toolbar-card {
  border-radius: 10px !important;
  border-color: #e3e8f0 !important;
  background: #fff;
}
.cj-switch {
  font-size: 0.8rem;
}

/* ── Tabla ────────────────────────────────────────────────────────── */
.cj-table-card {
  border-radius: 10px !important;
  border-color: #e3e8f0 !important;
  overflow: hidden;
}
.cj-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 8px 14px !important;
}
.cj-table >>> tbody tr:hover {
  background: #f0f4ff !important;
}
.cj-table >>> tbody tr td {
  font-size: 0.85rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 6px 14px !important;
}
</style>